import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const GpsBatteryIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-gpsBattery"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M46,16 L20,16 C18.8957153,16 18,16.8957153 18,18 L18,32 C18,33.1042847 18.8957153,34 20,34 L46,34 C47.1042847,34 48,33.1042847 48,32 L48,18 C48,16.8957153 47.1042847,16 46,16 Z M20,18 L46,18 L46,32 L20,32 L20,18 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="21 31 45 31 45 25 21 25"
        />
        <path
          d="M49,28 L49,22 C49,21.448 48.552,21 48,21 C47.448,21 47,21.448 47,22 L47,28 C47,28.552 47.448,29 48,29 C48.552,29 49,28.552 49,28"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M48,20 C46.8957153,20 46,20.8957153 46,22 L46,28 C46,29.1042847 46.8957153,30 48,30 C49.1042847,30 50,29.1042847 50,28 L50,22 C50,20.8957153 49.1042847,20 48,20 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M45,25 C45,28.314 39.627,31 33,31 C26.373,31 21,28.314 21,25 C21,21.686 26.373,19 33,19 C39.627,19 45,21.686 45,25"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M33,1 L33,1 C28.297,1 24.5,4.77 24.5,9.439 C24.5,14.475 31.292,25.067 31.292,25.067 C31.639,25.689 32.34,26 33,26 C33.66,26 34.327,25.689 34.708,25.067 C34.708,25.067 41.5,14.561 41.5,9.445 C41.5,4.776 37.703,1 33,1"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M33.2848029,0.00415362723 L33,0 C27.7464033,0 23.5,4.21601508 23.5,9.439 C23.5,11.1979354 24.1987384,13.5343336 25.4439721,16.3563378 C25.9025721,17.3956375 26.4281758,18.4821599 27.0080856,19.6015087 C27.7606228,21.0540651 28.5658261,22.4888729 29.3710487,23.8441096 L30.0059501,24.8952504 L30.4502023,25.6067932 C30.9333507,26.476698 31.9467225,27 33,27 C33.9698864,27 34.8873433,26.5511968 35.4524951,25.7534989 L35.6671145,25.4230305 L35.9923672,24.9031827 L36.2990917,24.4033042 L36.6275153,23.8587062 C37.4330042,22.5116391 38.2384657,21.0837239 38.9912524,19.6357843 C39.5913564,18.4815207 40.1331607,17.3611247 40.602704,16.2901372 C41.8186552,13.5166575 42.5,11.2057905 42.5,9.445 C42.5,4.32670027 38.4165001,0.15401935 33.2848029,0.00415362723 Z M33,2 L33.2410304,2.00362116 C37.2800917,2.12168445 40.5,5.41191341 40.5,9.445 C40.5,10.859561 39.8843194,12.9477199 38.7710092,15.4870841 C38.3204281,16.5148207 37.7975603,17.5960577 37.2167476,18.7132157 C36.630377,19.841064 36.0097982,20.958888 35.3823918,22.0342453 L34.7483383,23.10314 L34.2921598,23.8499518 L33.8682112,24.5240868 C33.6791663,24.8321455 33.3587045,25 33,25 C32.6751355,25 32.3784261,24.8654201 32.2186007,24.6600258 L31.8499916,24.0749908 L31.4107871,23.3572064 L31.0904513,22.8225154 C30.3037989,21.4985334 29.5171272,20.0967474 28.7839144,18.6814913 C28.2221561,17.5971787 27.7144174,16.5475867 27.2737522,15.5489316 C26.1327191,12.9630715 25.5,10.8474245 25.5,9.439 C25.5,5.32381276 28.8477701,2 33,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M37,9 C37,11.209 35.209,13 33,13 C30.791,13 29,11.209 29,9 C29,6.791 30.791,5 33,5 C35.209,5 37,6.791 37,9"
          fill="#00000"
          className={styles.defaultColor}
        />
      </g>
    </Icon>
  )
}
